import { DateTime, Duration } from "luxon";
import { validateExternalAccessTokenAPI, getUserSessionAPI, extendUserSessionAPI, endUserSessionAPI } from "../services/auth";
import * as constants from "./constants";
import queryString from "query-string";
import { Redirect } from "react-router-dom";
import React from "react";
import config from "../config/config";

const errResponse = {
  err: true,
  errCode: 401,
  errSourceURL: window.location.href,
};

export const setCookie = (name = "", val = "") => {
  // setting it to expire in 30 mins
  const date = DateTime.local().plus(Duration.fromObject({ minutes: 30 }));
  const value = val;

  document.cookie = name + "=" + value + "; expires=" + date.toHTTP() + "; path=/";
};

export const getCookie = (name = "") => {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");

  if (parts.length === 2) {
    return parts.pop()?.split(";").shift();
  }
};

export const deleteCookie = (name = "") => {
  // set it to expire in -1 days
  const date = DateTime.local().plus(Duration.fromObject({ days: -1 }));

  document.cookie = name + "=; expires=" + date.toHTTP() + "; path=/";
};

const extractUserInfoFromSession = (userSessionRes, isExternalToken) => {
  let gryphProduct = userSessionRes?.products?.find((p) => p.product === "Gryph");
  let activeUser = {
    clientKey: userSessionRes?.clientKey,
    emailAddress: userSessionRes?.emailAddress,
    isExternalToken: isExternalToken,
    goeLicense: gryphProduct?.license ? gryphProduct.license : "",
    expires: userSessionRes?.expires,
    sessionTimeout: userSessionRes?.sessionTimeout,
  };

  if (userSessionRes?.users?.length > 0) {
    let adminUser = userSessionRes?.users?.find((user) => user.userType === constants.ADMIN_USERTYPE);
    let agentUser = userSessionRes?.users?.find((user) => user.userType === constants.AGENT_USERTYPE);

    if (adminUser) {
      activeUser = { ...activeUser, ...adminUser, isAdmin: !isExternalToken };
      localStorage.setItem("userKey", adminUser.userKey);
    } else if (agentUser) {
      activeUser = { ...activeUser, ...agentUser, isAdmin: false };
      localStorage.setItem("userKey", agentUser.userKey);
    } else {
      let user = userSessionRes?.users[0];
      activeUser = { ...activeUser, ...user, isAdmin: false };
      localStorage.setItem("userKey", user.userKey);
    }
  } else {
    redirectUserToErrorPage();
  }

  return activeUser;
};

const handleExternalTokenFlow = async (externalToken) => {
  let res = await validateExternalAccessTokenAPI({ token: externalToken });

  if (res?.retCode === "0" && res?.retMsg === "success") {
    let userSessionRes = await getUserSessionAPI();

    if (userSessionRes?.retCode === 0) {
      return extractUserInfoFromSession(userSessionRes, true);
    } else {
      redirectUserToLogin();
      return {};
    }
  } else {
    redirectUserToErrorPage();
    return {};
  }
};

const handleRegularSessionFlow = async () => {
  let userSessionRes = await getUserSessionAPI();

  if (userSessionRes?.retCode === 0) {
    return extractUserInfoFromSession(userSessionRes, false);
  } else {
    redirectUserToLogin();
    return {};
  }
};

export const fetchActiveUserSession = async () => {
  let externalToken = queryString.parse(window.location.search).externalToken;

  if (externalToken != null && externalToken !== "") {
    return await handleExternalTokenFlow(externalToken);
  } else {
    return await handleRegularSessionFlow();
  }
};

export const redirectUserToLogin = () => {
  const redirectURL = config.CALENDAR_REDIRECT_LOGIN_URL + "?goto=" + window.location.href;
  window.location.replace(redirectURL);
};

export const redirectUserToMainLogin = async () => {
  await endUserSession();
  const redirectURL = config.CALENDAR_REDIRECT_LOGIN_URL + "?goto=" + window.location.href;
  window.location.replace(redirectURL);
};

export const redirectUserToErrorPage = () => {
  <Redirect to="*" errResponse={errResponse}></Redirect>;
};

export const extendUserSession = async () => {
  let res = await extendUserSessionAPI();
  if (res?.retCode !== 0) {
    // when no user session found
    redirectUserToLogin();
  }
};

export const endUserSession = async () => {
  localStorage.removeItem("userKey");
  await endUserSessionAPI();
};
